const urlHash = window.location.hash;

$(function () {
    if (urlHash == "#new-rating") {
        $("#new-rating").modal("show");
    }
});

$(function () {
    if (urlHash == "#new-question") {
        $("#new-question").modal("show");
    }
});
